export const setSidebarStatus = (mSlug, mTitle, sSlug, sTitle) => {
    return {
        type: 'sidebar/setSidebarStatus',
        mSlug: mSlug,
        mTitle: mTitle,
        sSlug: sSlug,
        sTitle: sTitle
    }
}
